(function() {
  'use strict';

  const configScript = document.currentScript || document.querySelector('script[data-chatbot-promotion]');
  if (!(configScript instanceof HTMLScriptElement)) return;

  const botId = configScript.dataset.botId;
  const imageUrl = configScript.dataset.imageUrl;
  const targetUrl = configScript.dataset.targetUrl;
  const enabled = configScript.dataset.enabled === 'true';

  document.documentElement.classList.toggle('deinfriseur-chat-promotion-enabled', enabled);
  document.documentElement.classList.toggle('deinfriseur-chat-promotion-disabled', !enabled);

  if (!enabled || !botId || !imageUrl || !targetUrl) return;

  const cooldownMilliseconds = 15 * 60 * 1000;
  const storageKey = `deinfriseur.chatbot-promotion.${botId}.last-shown`;
  const registrationKey = `deinfriseurChatbotPromotionRegistered_${botId}`;

  function escapeAttribute(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  const bannerHtml = [
    '<p class="deinfriseur-chat-banner">',
    '<span class="deinfriseur-chat-banner-label">Anzeige</span>',
    `<a href="${escapeAttribute(targetUrl)}" target="_blank" rel="noopener noreferrer" aria-label="Anzeige: Revlon Professional entdecken">`,
    `<img src="${escapeAttribute(imageUrl)}" alt="Revlon Professional entdecken" width="2172" height="724" loading="lazy" decoding="async">`,
    '</a>',
    '</p>'
  ].join('');

  function reservePromotionSlot() {
    const currentTime = Date.now();

    try {
      const storedValue = Number.parseInt(window.localStorage.getItem(storageKey), 10);
      const lastShown = Number.isFinite(storedValue) ? storedValue : 0;

      if (currentTime - lastShown < cooldownMilliseconds) return false;

      window.localStorage.setItem(storageKey, String(currentTime));
      return true;
    } catch (error) {
      return false;
    }
  }

  function appendPromotion(reply, context) {
    if (typeof reply !== 'string' || !context || context.botId !== botId) return reply;
    if (!reservePromotionSlot()) return reply;

    return `${reply}\n\n${bannerHtml}`;
  }

  function registerPromotionFilter() {
    if (window[registrationKey]) return true;
    if (!window.MwaiAPI || typeof window.MwaiAPI.addFilter !== 'function') return false;

    window.MwaiAPI.addFilter('ai.reply', appendPromotion, 10);
    window[registrationKey] = true;
    return true;
  }

  window.deinfriseurRegisterChatbotPromotion = registerPromotionFilter;

  if (registerPromotionFilter()) return;

  let attempts = 0;
  const registrationTimer = window.setInterval(function() {
    attempts += 1;

    if (registerPromotionFilter() || attempts >= 80) {
      window.clearInterval(registrationTimer);
    }
  }, 250);
})();
